export default __webpack_public_path__ + "static/media/educacion-crypto.807ba111.svg";